import { render, staticRenderFns } from "./TemplateDocuments.vue?vue&type=template&id=48264d94&scoped=true"
import script from "./TemplateDocuments.vue?vue&type=script&lang=ts"
export * from "./TemplateDocuments.vue?vue&type=script&lang=ts"
import style0 from "./TemplateDocuments.vue?vue&type=style&index=0&id=48264d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48264d94",
  null
  
)

export default component.exports